import React, { createContext, useContext } from 'react';

interface TooltipContainerContextType {
  container?: HTMLElement | ShadowRoot | null;
}

const TooltipContainerContext = createContext<TooltipContainerContextType>({
  container: null,
});

export const TooltipContainerProvider: React.FC<{
  container?: HTMLElement | ShadowRoot | null;
  children: React.ReactNode;
}> = ({ container, children }) => {
  return (
    <TooltipContainerContext.Provider value={{ container }}>
      {children}
    </TooltipContainerContext.Provider>
  );
};

export const useTooltipContainer = (): HTMLElement | ShadowRoot | undefined => {
  const { container } = useContext(TooltipContainerContext);
  return container || undefined;
};


